export {
  TrainingArticleV3,
  TrainingArticleV3Container,
  trainingArticleV3CurriculumOptions,
} from './container'

export { default } from './container'
